import React, { FC, memo } from 'react';
import { Switch } from 'udesk-ui';
import { AsrFilterConfig } from 'src/api/types';
import { SecondaryTypeMap } from '../../const';

interface TemplateProps {
    sourceType: number;
    value?: AsrFilterConfig;
    onChange?: (v: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { sourceType, value, onChange } = props;

    return (
        <Switch
            checked={value?.activeFlag === 1}
            onChange={(checked) =>
                onChange?.({
                    type: 1,
                    sourceType,
                    secondaryType: SecondaryTypeMap.ENABLED,
                    ...value,
                    activeFlag: checked ? 1 : 0,
                })
            }
        />
    );
});

export default Template;
